App.AuthLoginRoute = Ember.Route.extend
  session: Em.inject.service()

  beforeModel: ->
    if @get('session.loggedIn')
      @transitionTo('index')

  setupController: (controller, model) ->
    controller.set('loginValue', '')
    controller.set('passwordValue', '')